import { Select } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';

import { industryOptions } from '../../../../helpers/industries';
import type { CompanyDetailsFormValues } from '../CompanyDetails.types';
import { FieldRow } from '../FieldRow';

const industryMessages = defineMessages({
    motor: {
        id: '_.your_company.industry.motor',
        defaultMessage: 'Car Dealers, Garages & Mechanics'
    },
    construction: {
        id: '_.your_company.industry.construction',
        defaultMessage: 'Construction'
    },
    hospitality: {
        id: '_.your_company.industry.hospitality',
        defaultMessage: 'Hotels, Restaurants & Pubs'
    },
    manufacturing: {
        id: '_.your_company.industry.manufacturing',
        defaultMessage: 'Manufacturing, Food Processing & Printing'
    },
    retail: {
        id: '_.your_company.industry.retail',
        defaultMessage: 'Retail'
    },
    wholesale: {
        id: '_.your_company.industry.wholesale',
        defaultMessage: 'Wholesale'
    },
    agriculture: {
        id: '_.your_company.industry.agriculture',
        defaultMessage: 'Agriculture, Forestry & Fishing'
    },
    engineering: {
        id: '_.your_company.industry.engineering',
        defaultMessage: 'Architecture & Engineering'
    },
    business_support: {
        id: '_.your_company.industry.business_support',
        defaultMessage: 'Business Support Services'
    },
    cleaning: {
        id: '_.your_company.industry.cleaning',
        defaultMessage: 'Cleaning, Landscaping & Gardening'
    },
    education: {
        id: '_.your_company.industry.education',
        defaultMessage: 'Education & Training'
    },
    finance: {
        id: '_.your_company.industry.finance',
        defaultMessage: 'Finance & Insurance'
    },
    health: {
        id: '_.your_company.industry.health',
        defaultMessage: 'Health & Care'
    },
    it: {
        id: '_.your_company.industry.it',
        defaultMessage: 'IT & Communications'
    },
    leisure: {
        id: '_.your_company.industry.leisure',
        defaultMessage: 'Leisure / Other Services'
    },
    professional_services: {
        id: '_.your_company.industry.professional_services',
        defaultMessage: 'Professional Services'
    },
    property: {
        id: '_.your_company.industry.property',
        defaultMessage: 'Property & Real Estate'
    },
    media: {
        id: '_.your_company.industry.media',
        defaultMessage: 'Publishing, Film & Media Production'
    },
    transport: {
        id: '_.your_company.industry.transport',
        defaultMessage: 'Transport & Logistics'
    },
    other: {
        id: '_.your_company.industry.other',
        defaultMessage: 'Other'
    }
});

export const IndustryQuestion = () => {
    const intl = useIntl();
    const { register } = useFormContext<CompanyDetailsFormValues>();

    return (
        <FieldRow
            htmlFor="industry"
            label={
                <FormattedMessage
                    id="_.your_company.industry"
                    defaultMessage="Industry"
                />
            }
        >
            <Select
                {...register('industry')}
                id="industry"
                className="fs-exclude"
                placeholder={intl.formatMessage({
                    id: '_.select_field.placeholder',
                    defaultMessage: 'Select...'
                })}
            >
                {industryOptions.map(({ value, mappedValue, label }) => (
                    <option key={value} value={value}>
                        {mappedValue &&
                        industryMessages[
                            mappedValue as keyof typeof industryMessages
                        ]
                            ? intl.formatMessage(
                                  industryMessages[
                                      mappedValue as keyof typeof industryMessages
                                  ]
                              )
                            : label}
                    </option>
                ))}
            </Select>
        </FieldRow>
    );
};
